import { NgModule } from '@angular/core';

import { RedirectServiceModule } from '@fcom/common-booking/modules/redirect-service';
import { OrderApiModule } from '@fcom/dapi/api/order-api.module';

import { OrderSummaryService } from './services';

@NgModule({
  imports: [OrderApiModule, RedirectServiceModule],
  exports: [],
  declarations: [],
  providers: [OrderSummaryService],
})
export class OrderSummaryModule {}
